import { ref } from 'vue'

export interface ConfirmOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  discardText?: string // For 3-way dialogs
  type?: 'danger' | 'warning' | 'info'
}

type ConfirmCallback = (result: 'confirm' | 'cancel' | 'discard') => void

const isOpen = ref(false)
const options = ref<ConfirmOptions>({ title: '', message: '' })
let currentCallback: ConfirmCallback | null = null

export function useConfirm() {
  const showConfirm = (opts: ConfirmOptions): Promise<'confirm' | 'cancel' | 'discard'> => {
    options.value = {
      confirmText: 'Tasdiqlash',
      cancelText: 'Bekor qilish',
      type: 'warning',
      ...opts
    }
    isOpen.value = true
    
    return new Promise((resolve) => {
      currentCallback = resolve
    })
  }

  const handleResult = (result: 'confirm' | 'cancel' | 'discard') => {
    isOpen.value = false
    if (currentCallback) {
      currentCallback(result)
      currentCallback = null
    }
  }

  return {
    isOpen,
    options,
    showConfirm,
    handleResult
  }
}
